import {
  WhatsappAccountConnectionMessages,
  whatsappAccountConnectionMessages,
} from "./whatsappAccountConnectionMessages";
import {
  WhatsappCompletionMessages,
  whatsappCompletionMessages,
} from "./whatsappCompletionMessages";
import { WhatsappOverviewMessages, whatsappOverviewMessages } from "./whatsappOverviewMessages";
import {
  WhatsappPhoneConnectionMessages,
  whatsappPhoneConnectionMessages,
} from "./whatsappPhoneConnectionMessages";
import { SIDEBAR_MESSAGES, SidebarMessages } from "../../layout/sidebar";

export type WhatsAppConnectionMessages = SidebarMessages &
  WhatsappOverviewMessages &
  WhatsappAccountConnectionMessages &
  WhatsappCompletionMessages &
  WhatsappPhoneConnectionMessages & {
    pageTitle: string;
    breadCrumbTitle: string;

    nextButton: string;
    completeButton: string;

    overviewStepTitle: string;
    accountConnectionStepTitle: string;
    phoneConnectionStepTitle: string;
    completionStepTitle: string;
  };

export const WHATSAPP_CONNECTION_MESSAGES: WhatsAppConnectionMessages = {
  ...SIDEBAR_MESSAGES,
  pageTitle: "Whatsapp",
  breadCrumbTitle: "Plataformas",

  nextButton: "Próximo",
  completeButton: "Concluir",

  overviewStepTitle: "Visão Geral",
  accountConnectionStepTitle: "Conecte sua conta",
  phoneConnectionStepTitle: "Ative seu número",
  completionStepTitle: "Finalização",

  ...whatsappOverviewMessages,
  ...whatsappAccountConnectionMessages,
  ...whatsappCompletionMessages,
  ...whatsappPhoneConnectionMessages,
};
